import { TRESPONSE_NEEDLE_LIST, TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN } from '@monorepo/types';
import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { TranslateService } from '@ngx-translate/core';

export const UPDATE_NEEDLE_FORM_MODEL_KEYS = ['point', 'size', 'coating'];

export const UPDATE_NEEDLE_FORM_MODEL = {
  createNeedleDetailsModel: (
    needle: TRESPONSE_NEEDLE_LIST['needles'][number],
    dropdownList: TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN,
    translate: TranslateService,
  ): TLiftedFormModel => {
    const inputs: TLiftedFormModel['inputs'] = [
      {
        input: {
          type: 'INPUT',
          subType: 'text',
          value: needle.needleNumber,
        },
        metadata: {
          keyName: 'needleNumber',
          label: 'update_needle.NeedleNumber',
          isReadonly: true,
        },
      },
      {
        input: {
          type: 'INPUT',
          subType: 'text',
          value: needle.needleType,
        },
        metadata: {
          keyName: 'needleType',
          label: 'update_needle.NeedleType',
          isReadonly: true,
          removeFromPayload: true,
        },
      },
      {
        input: {
          type: 'INPUT',
          subType: 'text',
          value: needle.brand,
        },
        metadata: {
          keyName: 'brand',
          label: 'update_needle.Brand',
          isReadonly: true,
          removeFromPayload: true,
        },
      },
      {
        input: {
          type: 'DROPDOWN',
          value: needle.point,
          options: dropdownList.needlePoints.map((point) => ({ value: point, displayName: point })),
        },
        metadata: {
          keyName: 'point',
          label: 'update_needle.NeedlePoint',
        },
      },
      {
        input: {
          type: 'DROPDOWN',
          value: needle.size,
          options: dropdownList.sizes.map((size) => ({ value: size, displayName: size })),
        },
        metadata: {
          keyName: 'size',
          label: 'update_needle.Size',
        },
      },
      {
        input: {
          type: 'DROPDOWN',
          value: needle.coating,
          options: dropdownList.coatings.map((coating) => ({ value: coating, displayName: coating })),
        },
        metadata: {
          keyName: 'coating',
          label: 'update_needle.Coating',
        },
      },
      {
        input: {
          type: 'INPUT',
          subType: 'text',
          value: needle.inUseQuantity,
        },
        metadata: {
          keyName: 'In-Use quantity',
          label: 'update_needle.inUseQuantity',
          isReadonly: true,
          removeFromPayload: true,
        },
      },
    ];

    if (needle.mainStoreDetailsOpt) {
      inputs.push({
        input: {
          type: 'INPUT',
          subType: 'text',
          value: needle.mainStoreDetailsOpt.quantity,
        },
        metadata: {
          keyName: needle.mainStoreDetailsOpt.locationId.toString(),
          label: 'update_needle.MainStockQuantity',
          isRequired: true,
          isReadonly: !needle.mainStoreDetailsOpt.isUpdateAllowed,
        },
      });
    }

    needle.localStoreDetails.map((localInv) => {
      let locationDetails = {
        label: '',
        keyName: '',
        value: '',
      };
      switch (localInv.location.locationType) {
        case 'FLOOR_NEEDLE_STORE':
          locationDetails = {
            label: 'update_needle.FloorNo:',
            keyName: 'Floor ' + localInv.location.floor,
            value: localInv.location.floor,
          };
          break;
        case 'SECTION_NEEDLE_STORE':
          locationDetails = {
            label: 'update_needle.SectionNo:',
            keyName: 'Section ' + localInv.location.section,
            value: localInv.location.section,
          };
      }

      inputs.push({
        input: {
          type: 'INPUT',
          subType: 'text',
          value: localInv.quantity,
        },
        metadata: {
          keyName: localInv.locationId.toString(),
          label: `${translate.instant('update_needle.LocalStoreQuantity')} - ${locationDetails.keyName}`,
          isRequired: true,
          isReadonly: !localInv.isUpdateAllowed,
        },
      });
    });

    inputs.push({
      input: {
        type: 'TEXTAREA',
      },
      metadata: {
        keyName: 'reason',
        label: 'update_needle.QuantityUpdateReason:',
      },
    });

    return PIPELINE_FORM.sanitize({ inputs, isValid: false });
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
